<template>
  <div class="attachment">
    <div v-for="(item, index) in sourceFile" class="attachment-item">
      <!-- <div class="preview-attachment">
        <iframe v-if="attachMent[index]" :src="attachMent[index]"></iframe>
        <div v-else-if="!user">
          <a @click="login">请登录后查看</a>
        </div>
        <div v-else>附件获取超时，请刷新重试</div>
      </div> -->
      <div class="attachment-title" v-if="user">
        <span>{{ item.name }}</span>
        <span>
          <a @click="downloadUrl(item, id)" class="download-button">
            <img :src="downloadImg2Url" />
            <span>下载/查看</span>
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import downloadImg2 from "@/assets/img/download2x.png";
import Axios from "@/assets/js/ajax";
export default {
  name: "",
  data() {
    return {
      downloadImg2Url: downloadImg2,
    };
  },
  props: ["sourceFile", "id"],
  computed: {
    ...mapGetters("home", ["user"]),
    ...mapGetters("post", ["attachMent"]),
  },
  methods: {
    async downloadUrl(sourceFile, id) {
      console.log("downloadPrivate", sourceFile, id);
      let { uid, morphidae_file_id } = sourceFile;
      let finalValue = _.isNil(morphidae_file_id) ? uid : morphidae_file_id;
      console.log("downloadPrivate,finalValue", finalValue);
      let { data } = await Axios.get(`/downloadPrivate?id=${finalValue}`);
      data.data && window.open(data.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment {
  > .attachment-item {
    width: 850px;
    // height: 548px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.1);
    margin-bottom: 30px;
    iframe {
      border: none;
    }
    > .attachment-title {
      height: 50px;
      font-size: 16px;
      color: #333333;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .download-button {
        cursor: pointer;
      }
      > :first-child {
        display: inline-block;
        line-height: 50px;
        font-weight: bold;
      }
      > :nth-child(2) {
        display: inline-block;
        width: 110px;
        height: 38px;
        background: rgba(0, 147, 231, 1);
        border-radius: 28px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 20px;
          height: 20px;
        }
        a {
          font-size: 16px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          text-decoration: none;
          display: flex;
        }
      }
    }
    .preview-attachment {
      width: 850px;
      > iframe {
        width: 100%;
        height: 492px;
      }
      > div {
        width: 100%;
        height: 492px;
        text-align: center;
        padding: 250px;
        font-size: 34px;
        background-color: rgba(51, 51, 51, 0.2);
      }
    }
  }
}
</style>
